<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item title-wrap">
          <h1 class="title">Задачи</h1>
        </div>
        <div class="top-buttons">
          <div class="page__item" v-if="roleAccessExport" @click.stop>
            <download-excel :fields="exportTasksFields"
                            :header="`Отчет по задачам ${currentDateTime}`"
                            :name="`Задачи-${currentDateTime}.xls`"
                            :fetch="exportTasks"
            >
              <AppButtonSmExport title="Экспортировать"/>
            </download-excel>
          </div>
          <div class="page__item" v-if="roleAccessTaskCreate">
            <AppButtonSmAdd title="Добавить задачу" @click.stop.native="showCreateTaskModal"/>
          </div>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__search-wrap">
        <div class="page__item page__search">
          <SearchForm :value="searchValue" @form-submit="setTasksSearchValue"/>
        </div>
        <div class="page__item">
          <!-- TODO: сделать компонент мобильного фильтра-->
          <ButtonsFilter :state="filter"
                         v-if="mediaBreakpoint === 'desktop'"
                         @toggle-date-created="toggleFilterDateCreated"
                         @set-date-created-from="setFilterDateCreatedFrom"
                         @set-date-created-to="setFilterDateCreatedTo"
                         @clear-date-created="clearFilterDateCreated"
                         @toggle-date-finish="toggleFilterDateFinish"
                         @set-date-finish-from="setFilterDateFinishFrom"
                         @set-date-finish-to="setFilterDateFinishTo"
                         @apply-date="applyFilterDate"
                         @clear-date-finish="clearFilterDateFinish"
                         @toggle-list="toggleFilterList"
                         @clear-filter="clearFilter"
                         @inProgress-filter="setFilter('inProgress')"
                         @created-filter="setFilter('created')"
                         @watch-filter="setFilter('watch')"
          />
        </div>
      </div>
      <div class="page__row page__row_between task__selects">
        <div class="page__row">
          <div class="page__item">
            <AppSelect title="Статус"
                       placeholder="Выберите статус"
                       :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                       :value="filter.column"
                       :options="columnList"
                       @value-changed="setFilterColumn"
            />
          </div>
          <div class="page__item">
            <AppSelect title="Ответственный"
                       placeholder="Выберите ответственного"
                       :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                       :value="filter.assignee"
                       :is-users="true"
                       :options="users"
                       @value-changed="setFilterAssignee"
            />
          </div>
        </div>
        <!--TODO: временно закомментил переключение вида тасков, нужно определится каким образом будет осуществляться сортировка на api ри перетаскивании карточек и колонок, сейчас при перетаскивании ошибка-->
        <div class="page__item">
          <div class="view-switcher">
            <div class="view-switcher__item" :class="viewSwitcher.list ? 'active' : ''" @click.stop="setListView">
            <span class="view-switcher__icon">
              <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 1L5 0.999999" stroke="currentColor" stroke-width="2"/>
                <path d="M0 1L2 1" stroke="currentColor" stroke-width="2"/>
                <path d="M17 6L5 6" stroke="currentColor" stroke-width="2"/>
                <path d="M17 11L5 11" stroke="currentColor" stroke-width="2"/>
                <path d="M0 6L2 6" stroke="currentColor" stroke-width="2"/>
                <path d="M0 11L2 11" stroke="currentColor" stroke-width="2"/>
              </svg>
            </span>
              <span class="view-switcher__text">Список</span>
            </div>
            <div class="view-switcher__item" :class="viewSwitcher.board ? 'active' : ''" @click.stop="setBoardView">
            <span class="view-switcher__icon">
              <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="15" height="9" stroke="currentColor" stroke-width="2"/>
                <rect x="4" y="6" width="6" height="8" fill="#ffffff" stroke="currentColor" stroke-width="2"/>
              </svg>
            </span>
              <span class="view-switcher__text">Канбан</span>
            </div>
          </div>
        </div>
      </div>
      <div class="task__tabs-container" v-if="mediaBreakpoint === 'desktop'">
        <transition name="fade" mode="out-in">
          <div :key="'list'" class="view-tab" v-if="viewSwitcher.list">
            <div class="page__column">
              <div class="page__row page__table" v-if="tasks.length !== 0">
                <AppTable :data="tasks"
                          :headers="tableHeaders"
                          is-special
                          :is-menu-controls-active="true"
                          :menu-controls="roleAccessTaskActions"
                          @edit-this-item="updateTask"
                          @remove-this-item="showRemoveConfirmation"
                          @show-this-item="openTaskDetail"
                          @toggle-controls="toggleItemControls"
                          @toggle-children="toggleItemChildren"
                />
              </div>
              <div class="page__row mb-40"  v-else>
                <div class="no-records">
                  <AppNoRecordsPlaceholder text="Записи не найдены"/>
                </div>
              </div>
              <div class="page__row" v-if="tasks.length !== 0">
                <ThePagePagination :pageList="pagination.pageList"
                                   :currentPage="pagination.currentPage"
                                   :firstPage="pagination.firstPage"
                                   :lastPage="pagination.lastPage"
                                   @toggle-page-list="togglePageList"
                                   @prev-page="previousPage"
                                   @next-page="nextPage"
                                   @get-page="getPage"
                />
              </div>
            </div>
          </div>
          <div :key="'board'" class="view-tab" v-if="viewSwitcher.board">
            <TaskBoard :board="taskBoard"/>
          </div>
        </transition>
      </div>
      <div class="task__card-wrap" v-if="mediaBreakpoint !== 'desktop'">
        <div class="task__card-list mb-40" v-if="tasksCards.length !== 0">
          <div class="task__card-item"
               v-for="card in tasksCards"
               :key="card.id"
          >
            <AppPageCard :state="card"
                         @show-item="openTaskDetail"
                         @toggle-controls="toggleItemControls"
                         @update-item="updateTask"
                         @remove-item="showRemoveConfirmation"
            />
          </div>
        </div>
        <div class="page__row mb-40"  v-else>
          <div class="no-records">
            <AppNoRecordsPlaceholder text="Записи не найдены"/>
          </div>
        </div>
        <div class="page__mobile-pagination-wrap">
          <ThePagePagination :pageList="pagination.pageList"
                             :currentPage="pagination.currentPage"
                             :firstPage="pagination.firstPage"
                             :lastPage="pagination.lastPage"
                             @toggle-page-list="togglePageList"
                             @prev-page="previousPage"
                             @next-page="nextPage"
                             @get-page="getPage"
          />
        </div>
      </div>
    </section>
    <section class="section page__footer">
    </section>
    <transition name="fade">
      <TaskModal v-if="createTaskModal.active"
                 :state="createModalData"
                 @close-modal="closeCreateTaskModal"
                 @clear-close-modal="clearAndCloseCreateTaskModal"
                 @set-name="setNewTaskName"
                 @toggle-importance="toggleNewTaskImportance"
                 @set-description="setNewTaskDescription"
                 @toggle-link-tooltip="toggleNewTaskLinkTooltip"
                 @close-link-tooltip="closeNewTaskLinkTooltip"
                 @selection-range="setNewTaskInputSelectionRange"
                 @set-link-url="setNewTaskLinkUrl"
                 @toggle-tag-tooltip="toggleNewTaskTagTooltip"
                 @close-tag-tooltip="closeNewTaskTagTooltip"
                 @set-tag-text="setNewTaskTagText"
                 @attach-files="attachNewTaskFiles"
                 @remove-file="removeNewTaskFile"
                 @attach-link="attachNewTaskLink"
                 @attach-tag="attachNewTaskTag"
                 @remove-tag="removeNewTaskTag"
                 @clear-validation="clearNewTaskValidation"
                 @set-deadline="setNewTaskDeadline"
                 @set-parent-task="setNewTaskParentTask"
                 @set-column="setNewTaskColumn"
                 @add-assignee="addNewTaskAssignee"
                 @remove-assignee="removeNewTaskAssignee"
                 @add-watcher="addNewTaskWatcher"
                 @remove-watcher="removeNewTaskWatcher"
                 @save-task="createNewTask"
      />
    </transition>
    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       text="Вы действительно хотите удалить эту задачу?"
                       @confirm="removeTask"
                       @reject="closeRemoveConfirmation"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import SearchForm from '../../components/page/input/SearchForm'
import AppTable from '@/components/page/table/AppTable'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppButtonSmExport from '@/components/page/button/AppButtonSmExport'
import ThePagePagination from '@/components/page/ThePagePagination'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import TaskBoard from '@/components/task/TaskBoard'
import AppSelect from '@/components/page/input/AppSelect'
import ButtonsFilter from '@/components/task/ButtonsFilter'
import TaskModal from '@/components/task/TaskModal'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import { formatDate, formatDateTime, currentDateTime } from '@/utils/utils'
import axios from 'axios'
import { config, url } from '@/store'
import AppPageCard from '@/components/page/cards/AppPageCard'

export default {
  name: 'task-list',
  components: {
    AppPageCard,
    AppNoRecordsPlaceholder,
    AppConfirmation,
    TaskModal,
    ButtonsFilter,
    AppSelect,
    TaskBoard,
    ThePagePreloader,
    ThePagePagination,
    AppButtonSmAdd,
    AppButtonSmExport,
    AppTable,
    SearchForm
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        taskId: null
      },
      // заголовки колонок в экспортированной таблице
      exportTasksFields: {
        Название: 'name',
        'Дата создания': 'created_at',
        Статус: 'column',
        'Крайний срок': 'before_at',
        Подзадачи: 'child_count',
        Постановщик: 'owner',
        Ответственные: 'assignees'
      },
      // для хранения ссылки на текущий инпут сообщения и его выделенной области (модалка создания)
      modalMessageInput: null,
      modalInputSelectionRange: null
    }
  },
  computed: {
    tasks () {
      return this.$store.getters.getTaskList.map(task => {
        return ({
          id: task.id,
          /* id 3 соответствует колонке Завершена, is_completed пока не используется */
          deactive: task.column_id === 3,
          warning: Boolean(task.is_failed),
          isControlsActive: task.isControlsActive,
          values: [
            // имя
            { data: task.name },
            // дата создания
            // разбиваем на дату и время, дату форматируем и отрезаем секунды у времени
            { data: `${formatDateTime(task.created_at)}` },
            // статус
            { data: `${task.column_id ? task.column.name : 'Не указан'}` },
            // крайний срок
            { data: task.before_at ? `${formatDateTime(task.before_at)}` : 'Не установлен' },
            // колличество дочерних задач
            { data: task.child_count, class: 'task-child-count' },
            // постановщик
            { data: `${task.owner.profile.surname ? task.owner.profile.surname : ''} ${task.owner.profile.name}` },
            // ответственные
            { data: task.assignees.reduce((str, user) => { return str + `${user.profile.surname ? user.profile.surname : ''} ${user.profile.name}, ` }, '').slice(0, -2) }
          ]
        })
      })
    },
    tasksCards () {
      return this.$store.getters.getTaskList.map(task => {
        return ({
          id: task.id,
          /* id 3 соответствует колонке Завершена, is_completed пока не используется */
          isControlsActive: task.isControlsActive,
          title: task.name,
          data: [
            // разбиваем на дату и время, дату форматируем и отрезаем секунды у времени
            { name: 'Дата создания', value: formatDateTime(task.created_at) },
            { name: 'Крайний срок', value: task.before_at ? formatDateTime(task.before_at) : 'Не установлен' },
            { name: 'Статус', value: `${task.column_id ? task.column.name : 'Не указан'}`, modifier: `status ${task.column?.color}` },
            { name: 'Количество дочерних', value: task.child_count, modifier: 'task-child-count' },
            { name: 'Постановщик', value: `${task.owner.profile.surname ? task.owner.profile.surname : ''} ${task.owner.profile.name}` },
            { name: 'Ответственные', value: task.assignees.reduce((str, user) => { return str + `${user.profile.surname ? user.profile.surname : ''} ${user.profile.name}, ` }, '').slice(0, -2) }
          ]
        })
      })
    },
    createModalData () {
      return this.$store.getters.taskListCreateModal
    },
    users () {
      return [
        { id: 0, name: 'Не выбран', avatar: 'no-avatar' },
        ...this.$store.getters['[dictionaries] usersList']
      ]
    },
    columnList () {
      return [
        { id: 0, name: 'Все задачи' },
        ...this.$store.getters['[dictionaries] tasksColumnList']
      ]
    },
    tableHeaders () {
      return this.$store.getters.taskListTableHeaders
    },
    viewSwitcher () {
      return this.$store.getters.taskListViewSwitcher
    },
    taskBoard () {
      return this.$store.getters.taskListTaskBoard
    },
    searchValue () {
      return this.$store.getters.taskListSearchValue
    },
    pagination () {
      return this.$store.getters.taskListPagination
    },
    filter () {
      return this.$store.getters.taskListFilter
    },
    createTaskModal () {
      return this.$store.getters.taskListCreateModal
    },
    currentDateTime () {
      return formatDate(currentDateTime())
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    isLoading () {
      return this.$store.getters.taskListIsLoading
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessExport () {
      return this.$store.getters.getRoleRightsTasks.export
    },
    roleAccessTaskControls () {
      return this.$store.getters.getRoleRightsTasks.actionAccess
    },
    roleAccessTaskCreate () {
      return this.$store.getters.getRoleRightsTasks.actions.add
    },
    roleAccessTaskActions () {
      // нужно в любом случае исключать "добавить", потому что создание xерез отдельную кнопку
      return { ...this.$store.getters.getRoleRightsTasks.actions, add: false }
    }
  },
  methods: {
    getUserList () {
      const payload = {
        pagination: {
          currentPage: 1,
          perPage: 99999
        },
        filter: {
          search: ''
        }
      }
      this.$store.dispatch('[dictionaries] getUserList', payload)
    },
    getTaskColumnList () {
      this.$store.dispatch('[dictionaries] getTaskColumns')
    },
    updateTask (itemId) {
      this.$router.push({ path: `/task/info/${itemId}`, query: { update: 'true' } })
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.taskId = itemId
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.taskId = null
    },
    removeTask () {
      this.$store.dispatch('removeTask', this.removeConfirmation.taskId)
      this.removeConfirmation.active = false
      this.removeConfirmation.taskId = null
    },
    openTaskDetail (taskId) {
      this.$router.push({ path: `/task/info/${taskId}` })
    },
    toggleItemControls (itemId) {
      this.$store.dispatch('toggleTaskListTableItemControls', itemId)
    },
    toggleItemChildren (itemId) {
      this.$store.dispatch('toggleTaskListTableItemChildren', itemId)
    },
    setListView () {
      this.$store.dispatch('setTaskListListView')
    },
    setBoardView () {
      this.$store.dispatch('setTaskListBoardView')
    },

    // exportTasks
    async exportTasks () {
      const currentTake = this.pagination.currentTake
      const currentPage = this.pagination.currentPage
      const combinedFilter = this.filter.list.data
      const dateFilter = `${this.filter.date.created_from ? `search[created_from]=${this.filter.date.created_from}` : ''}&${this.filter.date.created_to ? `search[created_to]=${this.filter.date.created_to}` : ''}&${this.filter.date.finish_from ? `search[before_from]=${this.filter.date.finish_from}` : ''}&${this.filter.date.finish_to ? `search[before_to]=${this.filter.date.finish_to}` : ''}`
      const filter = `${this.filter.assignee.id !== 0 ? `search[assign_id]=${this.filter.assignee.id}` : ''}&${this.filter.column.id !== 0 ? `search[column]=${this.filter.column.id}` : ''}`
      const searchFilter = this.searchValue ? `search[any]=${this.searchValue}` : ''
      const expands = 'expand=assignees,watchers,owner,column'

      // из headers первого запроса берём общее количество подходящих задач и устанавливаем его в take (кол-во запрашиваемых записей) второго запроса
      const response = await axios.get(`${url}/tasks?orderBy=created_at&orderDir=DESC&per-page=${currentTake}&page=${currentPage}&${expands}&${filter}&${combinedFilter}&${dateFilter}&${searchFilter}`, config).then(response => {
        return axios.get(`${url}/tasks?orderBy=created_at&orderDir=DESC&per-page=${response.headers['x-pagination-total-count']}&${expands}&${filter}&${combinedFilter}&${dateFilter}&${searchFilter}`, config)
      }).catch(error => {
        console.log('ошибка получения списка задач для экспорта', error)
      })

      return response.data.data.map(task => {
        return ({
          // имя
          name: task.name,
          // дата создания
          created_at: formatDateTime(task.created_at),
          // статус
          column: `${task.column_id ? task.column.name : 'Не указан'}`,
          // крайний срок
          before_at: task.before_at ? formatDateTime(task.before_at) : 'Не установлен',
          // колличество дочерних задач
          child_count: task.child_count,
          // постановщик
          owner: `${task.owner.profile.surname ? task.owner.profile.surname : ''} ${task.owner.profile.name}`,
          // ответственные
          assignees: task.assignees.reduce((str, user) => {
            return str + `${user.profile.surname ? user.profile.surname : ''} ${user.profile.name}, `
          }, '').slice(0, -2)
        })
      })
    },

    // create modal
    showCreateTaskModal () {
      this.$store.dispatch('showTaskListCreateModal')
    },
    closeCreateTaskModal () {
      this.$store.dispatch('closeTaskListCreateModal')
    },
    clearAndCloseCreateTaskModal () {
      this.$store.dispatch('clearTaskListCreateModal')
    },
    setNewTaskName (text) {
      this.$store.dispatch('setTaskListModalName', text)
    },
    toggleNewTaskImportance () {
      this.$store.dispatch('toggleTaskListModalImportance')
    },
    setNewTaskDescription (text) {
      this.$store.dispatch('setTaskListModalDescription', text)
    },
    setNewTaskDeadline (date) {
      this.$store.dispatch('setTaskListModalDeadLine', date)
    },
    setNewTaskParentTask (task) {
      this.$store.dispatch('setTaskListModalParentTask', task)
    },
    setNewTaskColumn (column) {
      this.$store.dispatch('setTaskListModalColumn', column)
    },
    addNewTaskAssignee (user) {
      this.$store.dispatch('addTaskListModalAssignee', user)
    },
    removeNewTaskAssignee (user) {
      this.$store.dispatch('removeTaskListModalAssignee', user)
    },
    addNewTaskWatcher (user) {
      this.$store.dispatch('addTaskListModalWatcher', user)
    },
    removeNewTaskWatcher (user) {
      this.$store.dispatch('removeTaskListModalWatcher', user)
    },
    toggleNewTaskLinkTooltip () {
      this.$store.dispatch('taskListModalToggleLinkTooltip')
      const range = this.modalInputSelectionRange
      if (range) {
        this.$store.dispatch('taskListModalSetLinkText', range.toString())
      } else {
        this.$store.dispatch('taskListModalSetLinkText', '')
      }
    },
    closeNewTaskLinkTooltip () {
      this.$store.dispatch('taskListModalCloseLinkTooltip')
    },
    setNewTaskInputSelectionRange (data) {
      this.modalMessageInput = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (!data.range.collapsed && (data.range.commonAncestorContainer.childElementCount === undefined || data.range.commonAncestorContainer.childElementCount === 0)) {
        this.modalInputSelectionRange = data.range
      } else {
        this.modalInputSelectionRange = null
      }
    },
    setNewTaskLinkUrl (url) {
      this.$store.dispatch('taskListModalSetLinkUrl', url)
    },
    toggleNewTaskTagTooltip () {
      this.$store.dispatch('taskListModalToggleTagTooltip')
    },
    closeNewTaskTagTooltip () {
      this.$store.dispatch('taskListModalCloseTagTooltip')
    },
    setNewTaskTagText (text) {
      this.$store.dispatch('taskListModalSetTagText', text)
    },
    attachNewTaskFiles (files) {
      this.$store.dispatch('taskListModalAttachFiles', files)
    },
    removeNewTaskFile (data) {
      this.$store.dispatch('taskListModalRemoveFile', data)
    },
    attachNewTaskLink () {
      const range = this.modalInputSelectionRange
      const url = this.createModalData.attachment.linkTooltip.url.indexOf('https://') + 1 ? this.createModalData.attachment.linkTooltip.url : `https://${this.createModalData.attachment.linkTooltip.url}`

      if (range && this.createModalData.attachment.linkTooltip.url.length !== 0) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)
      }
      this.$store.dispatch('setTaskListModalDescription', this.modalMessageInput.innerHTML)
      this.$store.dispatch('taskListModalAttachLink')
    },
    attachNewTaskTag () {
      this.$store.dispatch('taskListModalAttachTag')
    },
    removeNewTaskTag (index) {
      this.$store.dispatch('taskListModalRemoveTag', index)
    },
    clearNewTaskValidation () {
      this.$store.dispatch('taskListModalClearValidation')
    },
    createNewTask () {
      this.$store.dispatch('taskListModalCreateTask')
    },

    // pagination
    togglePageList () {
      this.$store.dispatch('toggleTaskListPageList')
    },
    previousPage () {
      this.$store.dispatch('getTaskListPrevPage')
    },
    nextPage () {
      this.$store.dispatch('getTaskListNextPage')
    },
    getPage (pageNum) {
      this.$store.dispatch('getTaskListPage', pageNum)
    },

    // search
    setTasksSearchValue (searchValue) {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('setTasksSearchValue', searchValue)
    },

    // filter
    toggleFilterDateCreated () {
      this.$store.dispatch('toggleTaskListFilterDateCreated')
    },
    setFilterDateCreatedFrom (date) {
      this.$store.dispatch('setTaskListFilterDateCreatedFrom', date)
    },
    setFilterDateCreatedTo (date) {
      this.$store.dispatch('setTaskListFilterDateCreatedTo', date)
    },
    clearFilterDateCreated () {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('clearTaskListDateCreated')
    },
    toggleFilterDateFinish () {
      this.$store.dispatch('toggleTaskListFilterDateFinish')
    },
    setFilterDateFinishFrom (date) {
      this.$store.dispatch('setTaskListFilterDateFinishFrom', date)
    },
    setFilterDateFinishTo (date) {
      this.$store.dispatch('setTaskListFilterDateFinishTo', date)
    },
    applyFilterDate () {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('applyTaskListFilterDate')
    },
    clearFilterDateFinish () {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('clearTaskListDateFinish')
    },
    toggleFilterList () {
      this.$store.dispatch('toggleTaskListFilterList')
    },
    clearFilter () {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('clearTaskListFilter')
    },
    setFilter (filter) {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('setTaskListFilter', filter)
    },
    setFilterColumn (column) {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('setTaskListFilterColumn', column)
    },
    setFilterAssignee (user) {
      this.$store.dispatch('resetTaskListCurrentPage')
      this.$store.dispatch('setTaskListFilterAssignee', user)
    }
  },
  mounted () {
    this.getUserList()
    this.getTaskColumnList()
    this.$store.dispatch('getTasks')
    this.$store.dispatch('getTaskColumns')

    // нужно закрывать виджеты при переходе в задачи
    this.$store.commit('CLOSE_ASIDE_NOTIFICATION_WIDGET')
    this.$store.commit('CLOSE_ASIDE_DIALOG_WIDGET')
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/vars';
@import '../../assets/css/system/mixins';

.top-buttons {
  display: flex;
  flex-flow: row nowrap;
}

.task {
  &__selects {
    align-items: flex-end;
  }

  &__tabs-container {
    background: $color_sixth;
    padding: 24px 20px 20px;
    border-radius: 3px;
  }
}

.view-switcher {
  display: flex;
  flex-flow: row nowrap;

  &__item {
    display: flex;
    flex-flow: row nowrap;
    color: $color_deactive-second;
    cursor: pointer;
    user-select: none;
    margin-right: 24px;
    transition: .3s;

    &.active {
      color: $color_second-light;
    }

    &:hover {
      color: $color_second-light;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__text {
    display: inline-block;
    margin-left: 6px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}

// представление ввиде карточек
.task {
  &__card-wrap {}

  &__card-list {}

  &__card-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// адаптив
.page {
  &__header {
    @media screen and (max-width: $tablet_start) {
      .top-buttons {
        flex-direction: column;
      }
    }
  }
}

.task__selects {
  @media screen and (max-width: $tablet_start) {
    .page__row {
      width: 100%;
    }

    .page__item {
      width: 100%;
    }
  }
}

.view-switcher {
  @media screen and (max-width: $tablet_start) {
    display: none;
  }
}
// /адаптив
</style>
